import { OpstelApiClient } from "@opstel/query/v2/opstelClient";
import { createContext } from "react";

export interface OpstelClientContextProps {
  opstelClient: OpstelApiClient;
}

export const OpstelClientContext = createContext<OpstelClientContextProps | undefined>(undefined);
